import { Power4, gsap } from "gsap";

export const refinementSidebarAnimation = () => {
    const tl = gsap.timeline({
        defaults: {
            ease: Power4.easeOut,
            duration: 0.75,
        },
    });

    tl.fromTo(
        ".search-sidebar",
        {
            x: -20,
            opacity: 0,
        },
        {
            x: 0,
            opacity: 1,
        },
    );

    return tl;
};
